import { render, staticRenderFns } from "./subscription_orders.vue?vue&type=template&id=8069623a&scoped=true"
import script from "./subscription_orders.vue?vue&type=script&lang=js"
export * from "./subscription_orders.vue?vue&type=script&lang=js"
import style0 from "./subscription_orders.vue?vue&type=style&index=0&id=8069623a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8069623a",
  null
  
)

export default component.exports